import Vue from 'vue'
import Router from 'vue-router'

import Index from './views/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: './tasklist' },
    { path: '/tasklist', component: Index } // 待办列表首页
  ]
})
